// IMPORTS
// Modules
import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
// Components
import OHSApp from './../../onehivesystems/js/OHSApp';
import OHSCRUD from '../../onehivesystems/js/OHSCRUD';
// Assets
import './OnePort.scss';
import logo_oneport_light from './../../onehivesystems/logos/oneport_logo_long_white.svg';
import logo_oneport_dark from './../../onehivesystems/logos/oneport_logo_long_black.svg';
import icon_buildings_light from './../../onehivesystems/icons/buildings_light.svg';
import icon_buildings_dark from './../../onehivesystems/icons/buildings_dark.svg';
import icon_server_light from './../../onehivesystems/icons/server_light.svg';
import icon_server_dark from './../../onehivesystems/icons/server_dark.svg';
import icon_folder_light from './../../onehivesystems/icons/folder_light.svg';
import icon_folder_dark from './../../onehivesystems/icons/folder_dark.svg';
import icon_tasklist_light from './../../onehivesystems/icons/tasklist_light.svg';
import icon_tasklist_dark from './../../onehivesystems/icons/tasklist_dark.svg';
import icon_commands_light from './../../onehivesystems/icons/commands_light.svg';
import icon_commands_dark from './../../onehivesystems/icons/commands_dark.svg';
import icon_blueprints_light from './../../onehivesystems/icons/blueprints_light.svg';
import icon_blueprints_dark from './../../onehivesystems/icons/blueprints_dark.svg';
import icon_network_light from './../../onehivesystems/icons/network_light.svg';
import icon_network_dark from './../../onehivesystems/icons/network_dark.svg';
import icon_script_light from './../../onehivesystems/icons/script_light.svg';
import icon_script_dark from './../../onehivesystems/icons/script_dark.svg';
import icon_compare_light from './../../onehivesystems/icons/compare_light.svg';
import icon_compare_dark from './../../onehivesystems/icons/compare_dark.svg';
import icon_bulk_light from './../../onehivesystems/icons/bulk_light.svg';
import icon_bulk_dark from './../../onehivesystems/icons/bulk_dark.svg';
import icon_building_light from './../../onehivesystems/icons/building_light.svg';
import icon_building_dark from './../../onehivesystems/icons/building_dark.svg';


// COMPONENT
export default function OnePort (props) {
   // States and Variables
   const [devices, setDevices] = useState(null);
   const navigation = [
      {
         title: "Core Assets",
         links: [
            {
               title: "Locations",
               link: "/oneport/locations",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_buildings_dark : icon_buildings_light
            },
            {
               title: "Collections",
               link: "/oneport/collections",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_folder_dark : icon_folder_light
            },
            {
               title: "Devices",
               link: "/oneport/devices",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_server_dark : icon_server_light
            },
            {
               title: "Fields",
               link: "/oneport/fields",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_tasklist_dark : icon_tasklist_light
            },
            {
               title: "Commands",
               link: "/oneport/commands",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_commands_dark : icon_commands_light
            },
            {
               title: "Port Templates",
               link: "/oneport/porttemplates",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_blueprints_dark : icon_blueprints_light
            }
         ]
      },
      {
         title: "Tools",
         links: [
            {
               title: "Port Topology",
               link: "/oneport/porttopology",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_network_dark : icon_network_light
            },
            {
               title: "Custom Query",
               link: "/oneport/customquery",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_script_dark : icon_script_light
            },
            {
               title: "Port Compare",
               link: "/oneport/portcompare",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_compare_dark : icon_compare_light
            },
            {
               title: "Bulk Actions",
               link: "/oneport/bulkactions",
               icon: props.onehive.theme === props.onehive.themes.light ? icon_bulk_dark : icon_bulk_light
            }
         ]
      },
      {
         title: "Locations",
         links: devices
      }
   ];
   var alreadyLoading = false; // used to prevent double loading of topology due to theme changing

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveNav(false);
      buildNavigation();
      props.onehive.setAppWideContent({...props.onehive.appWideContent, oneport: {
         buildNavigation: buildNavigation
      }});
   }, []);

   // Listeners
   useEffect(function () {
      if (!alreadyLoading) {
         buildNavigation(); // rebuild navigation when theme changes
      }
   }, [props.onehive.theme])

   // Functions
   const buildNavigation = function () {
      alreadyLoading = true;
      OHSCRUD({
         url: '/v1/oneport/navigation/devices',
         method: 'GET',
         payload: null,
         success: function (data) {
            if (data.length > 0) {
               // Get Unique Locations
               var locations = [];
               data.forEach(function (item) {
                  if (!locations.includes(item.location_name)) {
                     locations.push(item.location_name);
                  }
               });
               
               // Sort Devices into Locations
               var master = [];
               locations.forEach(function (location) {
                  var parent = {};
                  parent.title = location;
                  parent.icon = props.onehive.theme === props.onehive.themes.light ? icon_building_dark : icon_building_light;
                  parent.sublinks = [];
                  data.forEach(function (item) {
                     var link = {};
                     if (item.location_name == location) {
                        link.title = item.device_name;
                        link.link = '/oneport/device?id=' + item.device_id;
                        link.icon = props.onehive.theme === props.onehive.themes.light ? icon_server_dark : icon_server_light;
                        parent.sublinks.push(link);
                     }
                  });
                  master.push(parent);
               });
               
               // Set Navigation
               setDevices(master);
            }
         },
         always: function () {
            alreadyLoading = false;
         }
      });
   }

   // Component
   return (
      <OHSApp onehive={props.onehive} navigation={navigation} logo={props.onehive.theme === props.onehive.themes.light ? logo_oneport_dark : logo_oneport_light} logolink='/oneport'>
         <Outlet />
      </OHSApp>
   );
};